import { render, staticRenderFns } from "./CompileData.vue?vue&type=template&id=54fed736&"
import script from "./CompileData.vue?vue&type=script&lang=js&"
export * from "./CompileData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports